import { Fade } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontWeight, TypographyStyledGlobal, fontSize } from '../../../theme';
import Title from '../../Title/title';
import BoxModalStyled from '../styled';
import { ExportGdprButtonStyled, CloseIconModalStyled, ModalStyled, ButtonsDiv } from './styled';

interface ExportGdprModalInterface {
    handleClose: () => void;
    openModal: boolean
    title: string
    handleDownload: () => void;
}

const ExportGdprModal: FC<ExportGdprModalInterface> = ({ handleClose, openModal, title, handleDownload }) => {
    const { t } = useTranslation('hotAlerts');
    const handleAcceptDownload = () => {
        handleClose();
        handleDownload();
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <Title content={title} modalTitle />
                    <CloseIconModalStyled onClick={handleClose} />
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        size={fontSize.m}
                        weight={fontWeight.semiRegular}
                    >
                        {t('summary.GdprAlert')}
                    </TypographyStyledGlobal>
                    <ButtonsDiv>
                        <ExportGdprButtonStyled
                            bgColor={colors.default}
                            bgColorHover={colors.defaultHover}
                            fontColor='white'
                            onClick={handleAcceptDownload}
                            style={{ marginRight: 'auto' }}
                        >
                            {t('summary.GdprAccept')}
                        </ExportGdprButtonStyled>
                        <ExportGdprButtonStyled bgColor={colors.default} bgColorHover={colors.defaultHover} fontColor='white' onClick={handleClose}>
                            {t('summary.GdprRefuse')}
                        </ExportGdprButtonStyled>
                    </ButtonsDiv>
                </BoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default ExportGdprModal;
